module.exports = __webpack_public_path__ + "static/media/Banner_storytelling_e_ux.16c8dfe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Storytelling/Banner_storytelling_e_ux.png
// module id = 195
// module chunks = 0